import React from "react";
import { string, node, oneOf } from "prop-types";
import Inline from "@insightfulscience/atomic-react/Inline";
import Block from "../../../Block";
import { Col } from "../../../Grid";
import ContentContainer from "../../atoms/ContentContainer";
import Link from "../../../Link";
import Heading from "../../../Heading";
import Image from "../../../Image";
import Paragraph from "../../../Paragraph";
import Section from "../../../Section";

const HomeResourcesHead = ({ title, children }) => {
	return (
		<Block spacing={{ mb: 20 }}>
			<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }} spacing={{ mt: 20 }}>
				{title}
			</Heading>
			<Paragraph sx={{ fontSize: "l", textAlign: "center" }}>{children}</Paragraph>
		</Block>
	);
};

HomeResourcesHead.propTypes = {
	title: string.isRequired,
	children: oneOf([string, node]),
};

const HomeResourcesBody = ({ children }) => {
	return children;
};

HomeResourcesBody.propTypes = {
	children: node.isRequired,
};

const HomeResourcesBodyItem = ({ title, srcImg, href, children }) => {
	return (
		<Link
			href={href}
			isBaseClassName={false}
			spacing={{ mb: 14 }}
			className="grid-x home-resources-body-item"
		>
			<Col Tag="span" shrink>
				<Inline
					sx={{ textAlign: "center" }}
					spacing={{ sm: { mb: 4 } }}
					utility={{ display: "block" }}
					className="w-18"
				>
					<Image src={srcImg} />
				</Inline>
			</Col>
			<Col Tag="span" auto>
				<Block spacing={{ ml: 4, md: { ml: 12 } }}>
					<Heading Tag="h3" sx={{ fontSize: "m", fontColor: "2" }} spacing={{ mb: 2 }}>
						{title}
					</Heading>
					<Paragraph sx={{ fontSize: "m", fontColor: "black--85" }} spacing={{ my: 0 }}>
						{children}
					</Paragraph>
				</Block>
			</Col>
		</Link>
	);
};

HomeResourcesBodyItem.propTypes = {
	title: string.isRequired,
	srcImg: string.isRequired,
	href: string.isRequired,
	children: string.isRequired,
};

const HomeResources = ({ children }) => {
	return (
		<Section className="pb-10">
			<ContentContainer lg={8} center>
				{children}
			</ContentContainer>
		</Section>
	);
};

HomeResources.propTypes = {
	children: node.isRequired,
};

HomeResources.Head = HomeResourcesHead;
HomeResources.Body = HomeResourcesBody;
HomeResources.Body.Item = HomeResourcesBodyItem;

export default HomeResources;
